import {
  DateFormats,
  ISmsUsageInvoiceResponseItem,
  currencyFormatter,
  toDecimal,
} from 'shared';
import { format } from 'date-fns';

import { Modal } from '../../../common/Atoms/Modal';
import { Table } from '../../../common/Atoms/Table';

interface ISmsInvoicesModalProps {
  show: boolean;
  invoices: ISmsUsageInvoiceResponseItem[];
  loading: boolean;
  onCancel: () => void;
}

export function SmsInvoicesModal({
  show,
  invoices,
  loading,
  onCancel,
}: ISmsInvoicesModalProps) {
  const rows = invoices.map(invoice => ({
    date: format(new Date(invoice.createdAt), DateFormats.UI_DISPLAY_LONG),
    amount: currencyFormatter(invoice.currency)(toDecimal(invoice.totalCents)),
    invoice: invoice.hostedInvoiceUrl ? (
      <a
        href={ invoice.hostedInvoiceUrl }
        target={ `_blank` }
        rel={ `noreferrer` }
        className={ `text-paidniceGreen-600 underline` }
      >
        { `View invoice` }
      </a>
    ) : `-`,
  }));

  return (
    <Modal
      setOpen={ onCancel }
      open={ show }
      title={ `SMS invoices` }
      width={ `lg` }
    >
      <Table
        headings={ [
          {
            name: `date`,
            label: `Date`,
            textAlign: `left`,
          },
          {
            name: `amount`,
            label: `Amount`,
            textAlign: `left`,
          },
          {
            name: `invoice`,
            label: `Invoice`,
            textAlign: `left`,
          },
        ] }
        rows={ rows }
        loading={ loading }
        emptyMessage={ `No SMS invoices found.` }
      />
    </Modal>
  );
}
